<div class="col-12">
    <div class="row">
        <div class="col-lg-2 cta-card d-flex">
            <a href="{{ context.url }}" class="innerlink"></a>
            <h2 class="align-self-center">See the live project</h2>
            <i class="fa fa-angle-right" aria-hidden="true"></i>
        </div>
        <div class="col-lg-10">
            <p [innerHtml]="context.content | filterHTML"></p>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/live-project/live-project.component.html